<template>
  <a-tooltip placement="right" style="visibility: visible;">
    <template slot="title">
      <span>{{ tooltipText }}</span>
    </template>
    <div class="sidebar-item text-center">
      <a-row type="flex" class="h-7" align="middle">
        <a-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" :class="toggled ? 'minimized-sidebar-btn-container' : ''">
          <a-button
          :ghost="darkTheme ? true : false"
          type="default"
          @click="$emit('click-event')"
          :class="toggled ? 'minimized-sidebar-btn' : 'sidebar-btn'"
          shape="circle" size="large">
            <a-icon :type="buttonIcon" :theme="buttonIconTheme" />
          </a-button>
        </a-col>
        <a-col :xl="12" :lg="12" :md="12" :sm="0" :xs="0" :class="toggled ? 'minimized-sidebar-btn-text-container' : 'sidebar-btn-text-container'">
          <h2 class="sidebar-btn-text-normal-font-size" :class="{ 'sidebar-btn-text-small-font-size': buttonTextSmallFontSize, 'dark-theme-font': darkTheme }">{{ buttonText }}</h2>
        </a-col>
      </a-row>
    </div>
  </a-tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SidebarButton',
  props: {
    tooltipText: String,
    buttonIcon: String,
    buttonIconTheme: {
      default: 'outlined',
      type: String
    },
    buttonText: String,
    buttonTextSmallFontSize: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapState({
      toggled: state => state.sidebar.toggled,
      darkTheme: state => state.darkTheme
    })
  }
}
</script>

<style scoped lang="scss">
.minimized-sidebar-btn-container{
  width: 100%;
}
.minimized-sidebar-btn{
  width: 50px;
  height: 50px;
  font-size: 22px;
}
.minimized-sidebar-btn-text-container{
  display: none;
}
.sidebar-item{
    min-height: 60px;
    margin-bottom: 1em;
}
.sidebar-btn{
    width: 60px;
    height: 60px;
    font-size: 27px;
}
.sidebar-btn-text-container{
    text-align: start;
}
.sidebar-btn-text-normal-font-size{
  font-size: 15px;
}
.sidebar-btn-text-small-font-size{
  font-size: 13px;
}
// Modification de la taille ds boutons en-dessous de 767px
@media screen and (max-width: 767px){
  .sidebar-btn{
    width: 50px;
    height: 50px;
    font-size: 22px;
  }
  .sidebar-btn-text-container{
    display: none;
  }
}
</style>
